<template>
    <div></div>
</template>

<script>
    import { mapMutations } from 'vuex';
    export default {
        data() {
            return {
            }
        },
        created() {
            var code = this.getUrlCode().code;
            if (!code) {
                this.getCode();
            }
            else {

                //登陆业务服务器（获取用户uid）【根据openid,获取用户名、密码进行登陆】 --- 单独登陆界面
                var self = this;
                self.get({
                    url: '/Common/GetOpenID/?code=' + code,
                    success: function (data_serve) {
                        var openid = data_serve;
                        if (openid) {
                            //保存获取到的openid
                            $cookies.set('openid', openid, 1 * 24 * 60 * 60);
                            self.$store.commit('set_openid', openid);
                            //ios系统（解决微信jsdk授权问题）
                            var client = self.$store.state.client;
                            if(client.is_ios){
                                var jump_url = window.location.origin;
                                window.location.href = jump_url;
                                return false;
                            }
                            //页面跳转（后边统一处理跳转路径跟踪）
                            self.$router.push({ name: 'main', params: { from: 'auth' } });
                        }
                        else {
                            self.$router.push({ name: 'main' });
                        }
                    },
                    error: function (err) {

                    }
                });
            }
        },
        methods: {
            ...mapMutations(['get', 'post']), //引入方法

            getCode() {
                var wxServe = 'https://open.weixin.qq.com/connect/oauth2/authorize?';
                // 1==2 为正式环境； 1==1 为测试环境
                if (1 == 2) {
                    wxServe = this.$store.state.url + "/home/Test_GetCode/?";
                }

                var appid = 'wx9a0ce3fb56ad6be5'; //小火柴新版（正式环境）：wx9a0ce3fb56ad6be5 
                //var appid = 'wx22c2b10081c39663'; //小火柴聊聊（测试环境）：wx22c2b10081c39663

                var redirect_uri = window.location.href; 
                // 非静默授权，第一次有弹框 &scope=snsapi_userinfo ;静默方式&scope=snsapi_base
                var otherParm = '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect';
                var jump_url = wxServe + 'appid=' + appid + '&redirect_uri=' + redirect_uri + otherParm;
                window.location.href = jump_url;
            },

            getUrlCode() { // 截取url中的code方法
                var url = location.search;
                var theRequest = new Object()
                if (url.indexOf("?") != -1) {
                    var str = url.substr(1)
                    var strs = str.split("&")
                    for (var i = 0; i < strs.length; i++) {
                        theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1])
                    }
                }
                return theRequest
            }
        }
    }
</script>
